// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1128":"b4e52aab","2976":"813275af","7389":"31d6cfe0","7415":"c59e2ffe","8223":"caa9e9a5","8367":"31d6cfe0"}[chunkId] + ".chunk.css";
};